import FunnelForm from "@/components/FunnelForm";
import { REGIONS, PROPERTY_TYPES, BEDROOM_OPTIONS } from "@/lib/constants";

// Contact comes at step 2 (not last) — abandons after that still become
// partial leads instead of vanishing.
const steps = [
  {
    title: "What are you looking to buy?",
    fields: [
      { name: "property_type", label: "Property type", type: "choice", multi: true, required: true, options: PROPERTY_TYPES },
      { name: "bedrooms", label: "Bedrooms", type: "choice", multi: true, required: true, options: BEDROOM_OPTIONS },
    ],
  },
  {
    title: "Where should Lamar send your matches?",
    fields: [
      { name: "name", label: "Full name", type: "text", placeholder: "Jane Doe", required: true },
      { name: "email", label: "Email", type: "email", placeholder: "you@email.com", required: true },
      { name: "phone", label: "Phone (optional)", type: "tel", placeholder: "+1 (555) 123-4567" },
    ],
  },
  {
    title: "Where do you want to live?",
    fields: [
      { name: "areas", label: "Neighborhoods / areas of interest", type: "choice", multi: true, required: true, options: REGIONS },
      { name: "budget", label: "Price range", type: "choice", required: true,
        options: ["< $400k", "$400k–$600k", "$600k–$900k", "$900k–$1.5M", "$1.5M+"] },
    ],
  },
  {
    title: "Timeline & financing",
    fields: [
      { name: "timeline", label: "When are you looking to buy?", type: "choice", required: true,
        options: ["0–3 months", "3–6 months", "6–12 months", "Just exploring"] },
      { name: "financing", label: "Financing status", type: "choice", required: true,
        options: ["Pre-approved", "Pre-qualified", "Need a lender", "All cash"] },
      { name: "message", label: "Anything else? (optional)", type: "textarea", placeholder: "Must-haves, parking, schools, etc." },
    ],
  },
];

export default function BuyerFunnel() {
  return (
    <FunnelForm
      leadType="buyer"
      subtitle="Buyer Concierge"
      title="Find your next home in New York."
      accent="#D4AF37"
      steps={steps}
      bgImage="https://images.unsplash.com/photo-1496588152823-86ff7695e68f"
      matchOnSuccess
    />
  );
}
